import ChatAction from "@/chatbot-library/ChatAction"

class ChatInput extends ChatAction {
  get name() {
    return "input"
  }

  getResponseContent(value) {
    return value
  }
}

export default ChatInput
